import template from './component.tpl.html';
import './controller';

/**
 * @ngdoc component
 * @name festzelt-os.modules.media.component:al-media-thumbnail
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example
 <example module="festzelt-os.modules.media">
 <file name="index.html">
 <al-media-thumbnail file="{}"></al-media-thumbnail>
 </file>
 </example>
 *
 */
angular
    .module('festzelt-os.modules.media')
    .component('alMediaThumbnail', {
        bindings: {
            file: '<'
        },
        controller: 'MediaAlMediaThumbnailComponentCtrl',
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/media/components/al-media-thumbnail/component.js